module.exports = __webpack_public_path__ + "static/media/instructions.fb1855fe.pdf";